import React from 'react';
import WarningModal from 'components/Modals/Warning/WarningModal';
import style from './ConsentModal.module.scss';

class ConsentModal extends WarningModal {
  render(): JSX.Element {
    const props = this.props;

    return <WarningModal className={style.modal} {...props} />;
  }
}

export default ConsentModal;
